import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Observable } from 'rxjs';
import { ThirdPartsAuthenticationList } from '~modules/thirdparts/common/entities/third-parts-authentication-list.entity';
import { ThirdPartsQontoRegateAuthenticationService } from '../services/third-parts-qonto-regate-authentication.service';


@Component({
  selector: 'app-qonto-regate-accounting-entries-api-exporter-configuration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule
  ],
  templateUrl: './qonto-regate-ae-api-exporter-configuration.component.html',
  styleUrls: ['./qonto-regate-ae-api-exporter-configuration.component.scss']
})
export class QontoRegateAccountingEntriesApiExporterConfigurationComponent {
  formGroup: FormGroup;

  connectionsOptions$?: Observable<ThirdPartsAuthenticationList[]>;

  constructor(
    readonly fb: FormBuilder,
    protected readonly authenticationService: ThirdPartsQontoRegateAuthenticationService,

  ) {
    this.formGroup = fb.group({
      authenticationId: [null, Validators.required]
    });

    this.connectionsOptions$ = this.authenticationService.list$();
  }
}